export default "__VITE_ASSET__Z1DkR2M0KlS20JjInS_S8Q__"